import React from 'react';

import logo from '../images/pm32i.png';

const e = React.createElement;


function StartFooter() {}
StartFooter.prototype = Object.create(React.Component.prototype);

StartFooter.prototype.render = function() {
  var linktext_terms = "algemene voorwaarden";
  var linktext_privacy = "privacybeleid";
  var text_madewith = "gemaakt met ❤️ door";
  if(this.props.lang === "EN") {
    linktext_terms = "terms and conditions"
    linktext_privacy = "privacy policy";
    text_madewith = "made with ❤️ by";
  }
  return e('footer', {className:"full footer"},
    e('div', {key:"1", className:"wrap"},
      e('div', {key:"2"}, [
        e('span', {key:"31"}, "©"+new Date().getFullYear()+" Polymedia.nl"),
        e('span', {key:"32"}, [
          e('span', {key:"321"}, " | "),
          e('a', {key:"322", href:"/terms", target:"_blank", rel:"noopener noreferrer"}, linktext_terms)
        ]),
        e('span', {key:"33"}, [
          e('span', {key:"331"}, " | "),
          e('a', {key:"332", href:"/privacy", target:"_blank", rel:"noopener noreferrer"}, linktext_privacy)
        ]),
        e('span', {key:"34"}, [
          e('span', {key:"341"}, " | "+text_madewith+" "),
          e('a', {key:"342", href:"https://polymedia.nl/", target:"_blank", rel:"noopener noreferrer"}, 
            e('img', {src:logo, alt:"polymedia.nl", style:{borderRadius:"50%", width:"32px"}})
          )
        ]),
      ])
    ));
}

export default StartFooter



//////////////////
// WEBPACK FOOTER
// ../_Skelet/src/components/Start_Footer.js
// module id = 934
// module chunks = 0